<!--
  * @Author: changyunxia
  * @Date:2020年10月14日 13:47:48
  * @LastEditors: changyunxia
  * @LastEditTime: @Date:2020年10月14日 13:47:48
  * @Description: 选择器
  * @FilePath:@/components/HelloWorld.vue arrow-down
-->
<template>
  <div>
    <van-field
      readonly
      clickable
      :label="label"
      :name="name"
      :value="value"
      :right-icon="rightIcon"
      @click="showPicker = true"
    />
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker
        ref="test"
        show-toolbar
        :columns="columns"
        @cancel="showPicker = false"
        @confirm="onConfirm"
        @change="onChange"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'PickerForm',
  components: {},
  props: {
    label: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    defaultValue: {
      type: String,
      default: null
    },
    pickerType: {
      type: String,
      default: null
    },
    rightIcon: {
      type: String,
      default: null
    },
    values: {
      type: String,
      default: ''
    },
    test: {
      type: Object,
      default: () => ({})
    },
    meetingTadiotime: {
      type: String,
      default: null
    },
    updInsflg: {
      type: String,
      default: null
    },
    meetingValue: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      value: this.defaultValue,
      columns: [],
      showPicker: false,
      hour: 8, // 小时
      minute: 2 // 分钟

    }
  },
  computed: {
    meetingTimes: {
      get: function() {
        return this.$store.getters.meeting_time
      },
      set: function() {}
    }
  },
  watch: {
    defaultValue(nVal) {
      this.value = nVal
      // 时间选择器的场合
      if (this.pickerType === 'time') {
        const l_hour = this.value.split(':')[0]
        if (l_hour !== null || l_hour !== undefined || l_hour !== '') {
          this.columns[0].defaultIndex = parseInt(this.value.split(':')[0])
        }
        if (this.value.split(':')[1] === '00') {
          this.columns[1].defaultIndex = 0
        } else if (this.value.split(':')[1] === '15') {
          this.columns[1].defaultIndex = 1
        } else if (this.value.split(':')[1] === '30') {
          this.columns[1].defaultIndex = 2
        } else if (this.value.split(':')[1] === '45') {
          this.columns[1].defaultIndex = 3
        }
      }
    },
    meetingTimes(newTime, oldTime) {
      var time = [
        { // 第一列
          values: [
            { text: '00', disabled: false },
            { text: '01', disabled: false },
            { text: '02', disabled: false },
            { text: '03', disabled: false },
            { text: '04', disabled: false },
            { text: '05', disabled: false },
            { text: '06', disabled: false },
            { text: '07', disabled: false },
            { text: '08', disabled: false },
            { text: '09', disabled: false },
            { text: '10', disabled: false },
            { text: '11', disabled: false },
            { text: '12', disabled: false },
            { text: '13', disabled: false },
            { text: '14', disabled: false },
            { text: '15', disabled: false },
            { text: '16', disabled: false },
            { text: '17', disabled: false },
            { text: '18', disabled: false },
            { text: '19', disabled: false },
            { text: '20', disabled: false },
            { text: '21', disabled: false },
            { text: '22', disabled: false },
            { text: '23', disabled: false }
          ],
          defaultIndex: this.hour
        },
        { // 第二列
          values: [
            { text: '00', disabled: false },
            { text: '15', disabled: false },
            { text: '30', disabled: false },
            { text: '45', disabled: false }
          ],
          defaultIndex: this.minute
        }
      ]
      if (this.pickerType === 'time') {
        // 当前天
        if (newTime === this.$moment().format('YYYY-MM-DD')) {
          time[0].values.forEach(i => {
            // 小于当前小时的全部disabled
            if (i.text < this.$moment().format('HH')) {
              i.disabled = true
            }
          })
          // 当前小时
          if (this.hour === parseInt(this.$moment().format('HH'))) {
            time[1].values.forEach(m => {
              // 小于当前分钟的全部disabled
              if (m.text < this.$moment().format('mm')) {
                m.disabled = true
              }
            })
          }
        // 不是当前天
        } else {
          time[0].values.forEach(i => {
            i.disabled = false
          })
        }
        this.columns = time
      }
    }
  },
  created() {
    if (this.values != null && this.values.length > 0) {
      this.value = this.values
    }
    // 时间选择器的场合
    if (this.pickerType === 'time') {
      const l_hour = this.defaultValue.split(':')[0]
      if (l_hour !== null || l_hour !== undefined || l_hour !== '') {
        this.hour = parseInt(this.defaultValue.split(':')[0])
      }
      if (this.defaultValue.split(':')[1] === '00') {
        this.minute = 0
      } else if (this.defaultValue.split(':')[1] === '15') {
        this.minute = 1
      } else if (this.defaultValue.split(':')[1] === '30') {
        this.minute = 2
      } else if (this.defaultValue.split(':')[1] === '45') {
        this.minute = 3
      }
    }
    var meeting = [
      { text: '会议室01', index: '01' },
      { text: '会议室02', index: '02' },
      { text: '会议室03', index: '03' },
      { text: '会议室04', index: '04' },
      { text: '会议室05', index: '05' },
      { text: '会议室06', index: '06' },
      { text: '会议室07', index: '07' }
    ]
    var time = [
      { // 第一列
        // values: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
        values: [
          { text: '00', disabled: false },
          { text: '01', disabled: false },
          { text: '02', disabled: false },
          { text: '03', disabled: false },
          { text: '04', disabled: false },
          { text: '05', disabled: false },
          { text: '06', disabled: false },
          { text: '07', disabled: false },
          { text: '08', disabled: false },
          { text: '09', disabled: false },
          { text: '10', disabled: false },
          { text: '11', disabled: false },
          { text: '12', disabled: false },
          { text: '13', disabled: false },
          { text: '14', disabled: false },
          { text: '15', disabled: false },
          { text: '16', disabled: false },
          { text: '17', disabled: false },
          { text: '18', disabled: false },
          { text: '19', disabled: false },
          { text: '20', disabled: false },
          { text: '21', disabled: false },
          { text: '22', disabled: false },
          { text: '23', disabled: false }
        ],
        defaultIndex: this.hour
      },
      { // 第二列
        values: [
          { text: '00', disabled: false },
          { text: '15', disabled: false },
          { text: '30', disabled: false },
          { text: '45', disabled: false }
        ],
        defaultIndex: this.minute
      }
    ]
    var week = [
      { text: '第一周', index: 1 },
      { text: '第二周', index: 2 },
      { text: '第三周', index: 3 },
      { text: '第四周', index: 4 },
      { text: '第五周', index: 5 }
    ]
    // 更新场合
    if (this.updInsflg === 'updata') {
      // 单条更新
      if (this.meetingValue === '0') {
        // 会议开始时间不为空
        if (this.meetingTimes != null) {
          var meetingTime = this.meetingTimes
        }
        let nowHours = ''
        // 当前分钟大于45
        if (this.$moment().format('mm') > '45') {
          nowHours = this.$moment().add(1, 'H').format('HH')
        } else {
          nowHours = this.$moment().format('HH')
        }
        if (this.pickerType === 'time') {
          // 会议开始时间 与当前日 是同一天
          if (meetingTime <= this.$moment().format('YYYY-MM-DD')) {
            time[0].values.forEach(i => {
              // 小于当前小时的全部disabled
              if (i.text < nowHours) {
                i.disabled = true
              }
            })
            // 当前小时
            if (this.hour <= parseInt(this.$moment().format('HH'))) {
              time[1].values.forEach(f => {
                // 小于当前分钟的全部disabled
                if (f.text < this.$moment().format('mm')) {
                  f.disabled = true
                }
              })
            }
          }
          this.columns = time
        } else if (this.pickerType === 'meeting') {
          this.columns = meeting
        } else {
          this.columns = week
        }
      // 周期更新
      } else {
        if (this.pickerType === 'time') {
          time[0].values.forEach(i => {
            i.disabled = false
          })
          time[1].values.forEach(i => {
            i.disabled = false
          })
          this.columns = time
        } else if (this.pickerType === 'meeting') {
          this.columns = meeting
        } else {
          this.columns = week
        }
      }
    // 新规场合
    } else {
      // 会议开始时间不为空
      if (this.meetingTimes != null) {
        var meetingTime1 = this.meetingTimes
      }
      let nowHours = ''
      // 当前分钟大于45
      if (this.$moment().format('mm') > '45') {
        nowHours = this.$moment().add(1, 'H').format('HH')
      } else {
        nowHours = this.$moment().format('HH')
      }
      if (this.pickerType === 'time') {
        // 会议开始时间 与当前日 是同一天
        if (meetingTime1 <= this.$moment().format('YYYY-MM-DD')) {
          time[0].values.forEach(i => {
            // 小于当前小时的全部disabled
            if (i.text < nowHours) {
              i.disabled = true
            }
          })
          // 当前小时
          if (this.hour === parseInt(this.$moment().format('HH'))) {
            time[1].values.forEach(f => {
              // 小于当前分钟的全部disabled
              if (f.text < this.$moment().format('mm')) {
                f.disabled = true
              }
            })
          }
        }
        this.columns = time
      } else if (this.pickerType === 'meeting') {
        this.columns = meeting
      } else {
        this.columns = week
      }
    }
  },
  methods: {
    onConfirm(value) {
      if (this.pickerType === 'time') {
        this.value = value[0].text + ':' + value[1].text + ':00'
        this.$emit('PickerForm', value)
        this.$emit('PickerFormEnd', value)
      } else if (this.pickerType === 'meeting') {
        this.value = value.text
        this.$emit('PickerForm', value)
      } else {
        this.value = value.text
        this.$emit('PickerForm', value)
      }
      this.showPicker = false
    },
    onChange(picker, value, index) {
      var meeting = [
        { text: '会议室01', index: '01' },
        { text: '会议室02', index: '02' },
        { text: '会议室03', index: '03' },
        { text: '会议室04', index: '04' },
        { text: '会议室05', index: '05' },
        { text: '会议室06', index: '06' },
        { text: '会议室07', index: '07' }
      ]
      var week = [
        { text: '第一周', index: 1 },
        { text: '第二周', index: 2 },
        { text: '第三周', index: 3 },
        { text: '第四周', index: 4 },
        { text: '第五周', index: 5 }
      ]
      var time = [
        { // 第一列
          // values: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
          values: [
            { text: '00', disabled: false },
            { text: '01', disabled: false },
            { text: '02', disabled: false },
            { text: '03', disabled: false },
            { text: '04', disabled: false },
            { text: '05', disabled: false },
            { text: '06', disabled: false },
            { text: '07', disabled: false },
            { text: '08', disabled: false },
            { text: '09', disabled: false },
            { text: '10', disabled: false },
            { text: '11', disabled: false },
            { text: '12', disabled: false },
            { text: '13', disabled: false },
            { text: '14', disabled: false },
            { text: '15', disabled: false },
            { text: '16', disabled: false },
            { text: '17', disabled: false },
            { text: '18', disabled: false },
            { text: '19', disabled: false },
            { text: '20', disabled: false },
            { text: '21', disabled: false },
            { text: '22', disabled: false },
            { text: '23', disabled: false }
          ],
          defaultIndex: this.hour
        },
        // 第二列
        {
          values: [
            { text: '00', disabled: false },
            { text: '15', disabled: false },
            { text: '30', disabled: false },
            { text: '45', disabled: false }
          ],
          defaultIndex: this.minute
        }
      ]
      // // 会议开始时间不为空
      // if (this.meetingTimes != null) {
      //   var meetingTime = this.meetingTimes
      // }
      // // let nowHours = ''
      // // // 当前分钟大于45
      // // if (this.$moment().format('mm') > '45') {
      // //   nowHours = this.$moment().add(1, 'H').format('HH')
      // // } else {
      // //   nowHours = this.$moment().format('HH')
      // // }
      // console.log('canshu', this.meetingTimes)
      // if (this.pickerType === 'time') {
      //   // 会议开始时间 与当前日 是同一天
      //   if (meetingTime === this.$moment().format('YYYY-MM-DD')) {
      //     timeyc[0].values.forEach(i => {
      //       // 小于当前小时的全部disabled
      //       if (i.text < this.$moment().format('HH')) {
      //         i.disabled = true
      //       }
      //     })
      //     // 当前小时
      //     if (parseInt(value[0].text) === parseInt(this.$moment().format('HH'))) {
      //       timeyc[1].values.forEach(f => {
      //         // 小于当前分钟的全部disabled
      //         if (f.text < this.$moment().format('mm')) {
      //           f.disabled = true
      //         }
      //       })
      //     } else {
      //       timeyc[1].values.forEach(f => {
      //         // 小于当前分钟的全部disabled
      //         if (f.text < this.$moment().format('mm')) {
      //           f.disabled = true
      //         }
      //       })
      //     }
      //   } else {
      //     timeyc[0].values.forEach(i => {
      //       // 小于当前小时的全部disabled
      //       if (i.text < this.$moment().format('HH')) {
      //         i.disabled = false
      //       }
      //     })
      //   }
      //   this.columns = timeyc
      // } else if (this.pickerType === 'meeting') {
      //   this.columns = meeting
      // } else {
      //   this.columns = week
      // }
      // 更新场合
      if (this.updInsflg === 'updata') {
        // 单条更新
        if (this.meetingValue === '0') {
          // 会议开始时间不为空
          if (this.meetingTimes != null) {
            var meetingTime = this.meetingTimes
          }
          let nowHours = ''
          // 当前分钟大于45
          if (this.$moment().format('mm') > '45') {
            nowHours = this.$moment().add(1, 'H').format('HH')
          } else {
            nowHours = this.$moment().format('HH')
          }
          if (this.pickerType === 'time') {
            // 会议开始时间 与当前日 是同一天
            if (meetingTime <= this.$moment().format('YYYY-MM-DD')) {
              time[0].values.forEach(i => {
                // 小于当前小时的全部disabled
                if (i.text < nowHours) {
                  i.disabled = true
                }
              })
              // 当前小时
              if (parseInt(value[0].text) === parseInt(this.$moment().format('HH'))) {
                time[1].values.forEach(f => {
                  // 小于当前分钟的全部disabled
                  if (f.text < this.$moment().format('mm')) {
                    f.disabled = true
                  }
                })
              } else {
                time[1].values.forEach(f => {
                  // 小于当前分钟的全部disabled
                  if (f.text < this.$moment().format('mm')) {
                    f.disabled = false
                  }
                })
              }
            }
            this.columns = time
          } else if (this.pickerType === 'meeting') {
            this.columns = meeting
          } else {
            this.columns = week
          }
        // 周期更新
        } else {
          time[0].values.forEach(i => {
            i.disabled = false
          })
          time[1].values.forEach(i => {
            i.disabled = false
          })
        }
      // 新规场合
      } else {
        // 会议开始时间不为空
        if (this.meetingTimes != null) {
          var meetingTime1 = this.meetingTimes
        }
        let nowHours = ''
        // 当前分钟大于45
        if (this.$moment().format('mm') > '45') {
          nowHours = this.$moment().add(1, 'H').format('HH')
        } else {
          nowHours = this.$moment().format('HH')
        }
        if (this.pickerType === 'time') {
          // 会议开始时间 与当前日 是同一天
          if (meetingTime1 <= this.$moment().format('YYYY-MM-DD')) {
            time[0].values.forEach(i => {
              // 小于当前小时的全部disabled
              if (i.text < nowHours) {
                i.disabled = true
              }
            })
            // 当前小时
            if (parseInt(value[0].text) === parseInt(this.$moment().format('HH'))) {
              time[1].values.forEach(f => {
                // 小于当前分钟的全部disabled
                if (f.text < this.$moment().format('mm')) {
                  f.disabled = true
                }
              })
            } else {
              time[1].values.forEach(f => {
                // 小于当前分钟的全部disabled
                if (f.text < this.$moment().format('mm')) {
                  f.disabled = false
                }
              })
            }
          }
          this.columns = time
        } else if (this.pickerType === 'meeting') {
          this.columns = meeting
        } else {
          this.columns = week
        }
      }
    }
  }
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类

</style>
